import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ProfileService } from '../services/profile.service';
import { ProfileBaseGuard } from './profile-base.guard';
import { AuthService } from '@dg/shared-services';

/**
 * Route guard to control the accessibility of the /profile/:id/flex-ed route
 */
@Injectable({
  providedIn: 'root',
})
export class ProfileFlexEdGuard extends ProfileBaseGuard {
  constructor(
    protected profileService: ProfileService,
    protected router: Router,
    protected authService: AuthService
  ) {
    super(router, profileService, authService);
    this.isAuthorized = this.authService?.authUser?.defaultOrgInfo?.hasPex;
  }
}
